import { render } from "./Tabbar.vue?vue&type=template&id=43ffa349&scoped=true"
import script from "./Tabbar.vue?vue&type=script&lang=js"
export * from "./Tabbar.vue?vue&type=script&lang=js"

import "./Tabbar.vue?vue&type=style&index=0&id=43ffa349&lang=scss&scoped=true"

import exportComponent from "E:\\h5template\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43ffa349"]])